export type RedirectEntity = 'rx' | 'patient' | 'copay'
export enum RedirectDestination {
  Dash = 'dash',
  Tpos = 'tpos',
  Tpcs = 'tpcs',
}
